var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c(
        "div",
        {
          staticClass: "main-wrapper signin-form center signin-wrapper-padding"
        },
        [
          _c(
            "div",
            { staticClass: "text-align-center margin-bottom-20 mm-logo" },
            [_c("img", { attrs: { src: require("@/assets/MM-logo.png") } })]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-align-center margin-bottom-20",
              staticStyle: {
                "font-size": "14px",
                color: "#0C2E3E",
                "font-weight": "600",
                "margin-top": "30px"
              }
            },
            [
              _vm._v(
                "\n        The link you are trying to access is either expired, already used or invalid.\n      "
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "text-align-center margin-bottom-35",
              staticStyle: { "font-size": "14px", color: "#0C2E3E" }
            },
            [
              _vm._v(
                "\n        If you have any questions, please contact Mentor Mentee Team at (888) 800-9250 or info@mentormentee.com.\n      "
              )
            ]
          )
        ]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-53cdacc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-53cdacc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/token_validation_failed.vue
// module id = null
// module chunks = 